__webpack_require__.p = "https://shopify-account-switcher.web.app/";